import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
    changeCurrentPath,
    fetchEmptyPdfList,
    getEmptyPdfItems,
    resetMainListState,
    resetConsigneeListStateNew,
} from '../../actions';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';

import ReloadModal from '../../common/components/dialog/reload-dialog';
import ErrorDialog from '../../common/components/dialog/error-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';

import PdfViewer from "../../common/components/viewer/brank-pdf-viewer";

class EmptyPdf extends Component {

    constructor(props) {
        super(props);
        this.state = {
            IsLogin : false,
            IsProcess : false,
        }
    }
	/** override methods **/
    UNSAFE_componentWillMount() {
	    const {dispatch} = this.props;
        dispatch(fetchEmptyPdfList());
        dispatch(resetMainListState());
        dispatch(resetConsigneeListStateNew());
	}
    
    /** override methods **/
	componentDidMount() {
		const { dispatch, history } = this.props;
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}
    
    /** event handlers **/
	handleShowPdf = (denpyoyoshiki_cd) =>{
	    const {auth, dispatch} = this.props;
	    dispatch(getEmptyPdfItems({
            SessionID:auth.SessionID,
            denpyoyoshiki_cd
	    }));
    };


    render() {
        const {settings} = this.props;

        const data = settings.data;
        const pdfPath = this.props.settings.pdfPath;
        const dialogOpen = (pdfPath !== undefined);

        let list = [];

        for(let i in data){
            list.push(<li key={i}><span onClick={this.handleShowPdf.bind(this,data[i].DenpyoYoshikiCD)}>{data[i].DenpyoYoshikiName}</span></li>)
        }


        return (
            <div id="main_container">
                {settings.isFetching &&
                <Progress/>
                }
                <SpNav history={this.props.history}/>
                <Header history={this.props.history}/>
                <article>
                    <section className="title_area">
                        <h2>空伝票出力</h2>
                    </section>
                    <section id="jigyousha_list">
                        <ul>
                            {list}
                        </ul>
                    </section>
                </article>
                <Footer/>
                <ErrorDialog
                    open={this.props.settings.isProcessError}
                />
				<ReloadModal />
                <LogoutModal />
                {dialogOpen &&
                <PdfViewer filePath={pdfPath}/>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
  return {
	  navigation : state.navigation,
      auth: state.auth,
      settings : state.emptyPdfSettings,
	  
  };
}
export default connect(mapStateToProps)(EmptyPdf);



// WEBPACK FOOTER //
// ./src/routes/empty-pdf/index.js